/* Publish by EComposer at 2026-10-22 02:54:06*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-zoxsr4t8j"]=  window.__ectimmers["ecom-zoxsr4t8j"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-zoxsr4t8j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zoxsr4t8j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jxc4diw86n8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jxc4diw86n8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1u9wzszoew9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1u9wzszoew9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f13kq1ktsm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f13kq1ktsm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0nvmj2a9fh0n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0nvmj2a9fh0n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ttoeu9gms1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ttoeu9gms1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2larbez4gbi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2larbez4gbi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-06iaxqu5wssq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-06iaxqu5wssq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2rc1savrc8o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2rc1savrc8o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5nkqdsx4e2e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5nkqdsx4e2e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c2ng4cq3vhf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c2ng4cq3vhf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hz4vg3zp1lo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hz4vg3zp1lo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r6asmu0qc1o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r6asmu0qc1o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ghpz7axwvs6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ghpz7axwvs6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kuazjcdh8tb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kuazjcdh8tb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k9qre6cbjz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k9qre6cbjz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-51skry8zc26').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-51skry8zc26', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-97fi9s782nu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-97fi9s782nu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ejh4cndaru').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ejh4cndaru', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2kktxhl1jxl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2kktxhl1jxl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y3faunzboy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y3faunzboy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nkiq74ptga').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nkiq74ptga', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l468tha0pph').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l468tha0pph', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-06ilxww2toxu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-06ilxww2toxu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ijalqpunrzm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ijalqpunrzm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fx4lvi2zvug').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fx4lvi2zvug', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hwc47gfavc8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hwc47gfavc8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gnxjs6bw2bb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gnxjs6bw2bb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bvjwnjhbr1p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bvjwnjhbr1p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hekvzv84y25').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hekvzv84y25', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pq6np1w9iaq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pq6np1w9iaq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rq00hrrscj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rq00hrrscj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oob3crzxz2b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oob3crzxz2b', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}